import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import _ from 'underscore';
import materialTheme from '../../reactMaterialTheme';
import http from '../../shared/http';
import './HeadlineField.css';
import HeadlineAnalysis from './HeadlineAnalysis';

class HeadlineField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      analysis: null
    };
    this.showHeadlineError = this.showHeadlineError.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.fetchScore = _.debounce(this.fetchScore.bind(this), 500);
  }

  handleChange(event) {
    const { value } = event.target;

    this.props.onChange(event);
    this.fetchScore(value);
  }

  fetchScore(headline) {
    if (headline === "") {
      this.setState({ analysis: null });
      return;
    }

    return http
      .post('/headlines/analyze', { headline })
      .then(response => {
        this.setState({ analysis: response.data });
      });
  }

  showHeadlineError() {
    return this.props.headline && this.props.headline.length > 90;
  }

  render() {
    return (
      <MuiThemeProvider theme={materialTheme}>
        <TextField
          label={<label htmlFor="headline">Headline</label>}
          className="headline-input mb2"
          value={this.props.headline}
          onChange={this.handleChange}
          name="headline"
          id="headline"
          inputProps={{ 'data-testid': 'headline-input' }}
          onFocus={event => event.target.select()}
          required
          disabled={this.props.disabled}
        />

        {this.showHeadlineError() && (
          <small
            className="error-message error mb2 mt2"
            data-testid="headline-error"
          >
            Headline must be 90 characters or less
          </small>
        )}

        {this.props.headline && this.state.analysis && (
          <HeadlineAnalysis analysis={this.state.analysis} />
        )}
      </MuiThemeProvider>
    );
  }
}

HeadlineField.propTypes = {
  headline: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

HeadlineField.defaultProps = {
  headline: '',
  disabled: false
};

export default HeadlineField;
